import React, { useEffect, useState, useContext } from "react";
import formValidations from "../../variables/form-validations";
import onboardService from "../../services/api/onboard-service";
import projectsService from "../../services/api/projects-service";
import TimezoneSelect from "react-timezone-select";
import { useCookies } from "react-cookie";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom";
import "../plan/plan.css";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  CardText,
  CardImg,
  Label,
  FormGroup,
  Form,
  Input,
  Alert,
  Spinner,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Table,
  Container,
  Row,
  Col,
} from "reactstrap";

import Select from "react-select";
import planService from "../../services/api/plan-service";
import ProjectContext from "../../ProjectContext";
import authService from "../../services/api/auth-service";
import ReactBSAlert from "react-bootstrap-sweetalert";
import { useLocation } from 'react-router-dom';
import Moment from 'react-moment'
const PayManual = (props) => {
  let showWarning = true;
  const projectDetails = useContext(ProjectContext);
  if(props.location.state === "buyPlan") {
    showWarning = false;
  }
  const history = new useHistory();
  const subscriptionId = new URLSearchParams(props.location.search).get("subscriptionid");
  const projectId = new URLSearchParams(props.location.search).get("projectid");
  let getProjectSlug = new URLSearchParams(props.location.search).get(
    "project"
  );
  if (!getProjectSlug) {
    history.push({
      search: "?project=" + projectDetails.slug,
    });
  }

  const [planDetails, setPlanDetails] = useState({});
  const [componentRendered, setComponentRendered] = useState(false);
  const [showPopup, setShowPopup] = useState({ alert: null });
  const [showLoader, setShowLoader] = useState(false);
  const [showLoaderAtButton, setShowLoaderAtButton] = useState(false);

  const [showProceedButton, setShowProceedButton] = useState(true);
  const [isPlanRenewed, setIsPlanRenewed] = useState(false);
  const [subscription, setSubscription] = useState(false);
//   useEffect(() => {
//      (async ()=>{
//       const response = await planService.isPlanRenewed(projectDetails.id);
//       if(response.status){
//         if(response.data) {
//           setIsPlanRenewed(true);
//         }else {
//           setIsPlanRenewed(false);
//         }
//       } 
//      })();
//   },[]);
  useEffect(() => {
    (async () => {
      setShowLoader(true);

      const response = await planService.getSubscription(projectId,subscriptionId);
      if (response.status && response.data) {
        console.log(response.data);
        setSubscription(response.data);
      }
      setShowLoader(false);
      setComponentRendered(true);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.async = true;
      document.body.appendChild(script);
    })();
  }, []);
  const hideAlert = () => {
    setShowPopup({
      alert: null,
    });
  };
  const handleOnPurchase = async (projectId, planId) => {
        await processPayment(projectId, planId);
        return false;
  }
  const handleConfirm = async (projectId, planId) => {
    hideAlert();
    await processPayment(projectId, planId);
  }
  const processPayment = async (projectId, subscriptionId) => {
    setShowLoaderAtButton(true);
    setShowProceedButton(false);

    let userDetails = await authService.getLoggedInUser();
    console.log(userDetails);
    let planOrderData = await planService.createManualPayOrder(
      projectId,
      subscriptionId
    );
    if (planOrderData.status && planOrderData.data) {
      let orderData = planOrderData.data;
      if (orderData === "payments_disabled") {
        setShowPopup({
          alert: (
            <ReactBSAlert
              danger
              style={{ display: "block", marginTop: "-100px" }}
              title="Payments are not enabled. Please try later!"
              onConfirm={() => hideAlert()}
              onCancel={() => hideAlert()}
              confirmBtnBsStyle="info"
              btnSize=""
            >
              Payments are not enabled. Please try later!
            </ReactBSAlert>
          ),
        });

        setTimeout(() => {
          hideAlert();
        }, 3000);
        setTimeout(() => {
          window.location.reload();
        }, 2000);
        return;
      }

      console.log("PlanData:", planOrderData.data);
      var options = {
        key: orderData.razorpay_key_id,
        amount: orderData.amount, // 2000 paise = INR 20, amount in paisa
        name: orderData.name,
        description: orderData.description,
        order_id: orderData.order_id,
        handler: async function (response) {
          console.log("Handler", response);
          var values = {
            razorpay_signature: response.razorpay_signature,
            razorpay_order_id: response.razorpay_order_id,
            razorpay_payment_id: response.razorpay_payment_id,
            amount: orderData.amount,
            transaction_id: orderData.transaction_id,
          };

          let planVerifyPayment = await planService.verifyManualPayment(
            projectId,
            subscriptionId,
            values
          );
          if (planVerifyPayment.status && planVerifyPayment.data.verified) {
            // alert("success")
            setShowPopup({
              alert: (
                <ReactBSAlert
                  success
                  style={{
                    display: "block",
                    marginTop: "-100px",
                  }}
                  title="Payment Successfull!"
                  onConfirm={() => hideAlert()}
                  onCancel={() => hideAlert()}
                  confirmBtnBsStyle="info"
                  btnSize=""
                >
                  Payment Done successfully.
                </ReactBSAlert>
              ),
            });

            setTimeout(() => {
              hideAlert();
              //  history.push("/plan/details");
              window.location.href =
                "/plan/details?project=" + projectDetails.slug;
            }, 2000);
          } else {
            // alert("failure")
            setShowPopup({
              alert: (
                <ReactBSAlert
                  danger
                  style={{
                    display: "block",
                    marginTop: "-100px",
                  }}
                  title="Payment Failed!"
                  onConfirm={() => hideAlert()}
                  onCancel={() => hideAlert()}
                  confirmBtnBsStyle="info"
                  btnSize=""
                >
                  Payment Failed.
                </ReactBSAlert>
              ),
            });
            setTimeout(() => {
              hideAlert();
            }, 3000);
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          }
        },
        prefill: {
          name: userDetails.data.id,
          email: userDetails.data.email,
          contact: "",
        },
        notes: {
          address: "",
          payment_for : "sortd_manual_pay"
        },
        theme: {
          color: "#528ff0",
        },
        modal: {
          ondismiss: function () {
            setShowPopup({
              alert: (
                <ReactBSAlert
                  danger
                  style={{
                    display: "block",
                    marginTop: "-100px",
                  }}
                  title="Transaction Failed!"
                  onConfirm={() => hideAlert()}
                  onCancel={() => hideAlert()}
                  confirmBtnBsStyle="info"
                  btnSize=""
                >
                  Payment Failed.
                </ReactBSAlert>
              ),
            });
            setTimeout(() => {
              hideAlert();
            }, 3000);
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          },
        },
      };
      setShowLoaderAtButton(false);
      setShowProceedButton(true);
      console.log(options);
      var rzp1 = new window.Razorpay(options);
      rzp1.open();
      rzp1.on("payment.failed", async function (response) {
        // alert(response.error.code);
        // alert(response.error.description);
        // alert(response.error.source);
        // alert(response.error.step);
        // alert(response.error.reason);
        // alert(response.error.metadata.order_id);
        // alert(response.error.metadata.payment_id);
        rzp1.close();
        setShowPopup({
          alert: (
            <ReactBSAlert
              danger
              style={{ display: "block", marginTop: "-100px" }}
              title="Transaction Failed!"
              onConfirm={() => hideAlert()}
              onCancel={() => hideAlert()}
              confirmBtnBsStyle="info"
              btnSize=""
            >
              Payment Failed.
            </ReactBSAlert>
          ),
        });
        var values = {
          razorpay_signature: "",
          razorpay_order_id: "",
          razorpay_payment_id: "",
          amount: "",
          transaction_id: orderData.transaction_id,
        };

        await planService.verifyManualPayment(projectId, subscriptionId, values);

        setTimeout(() => {
          hideAlert();
        }, 3000);
      });
    } else {
      setShowPopup({
        alert: (
          <ReactBSAlert
            danger
            style={{ display: "block", marginTop: "-100px" }}
            title="Some Error Occured. Please try again!"
            onConfirm={() => hideAlert()}
            onCancel={() => hideAlert()}
            confirmBtnBsStyle="info"
            btnSize=""
          >
            Some Error Occured. Please try again!
          </ReactBSAlert>
        ),
      });

      setTimeout(() => {
        hideAlert();
      }, 3000);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  };

  return (
    <div className="content mt-30">
      {showPopup.alert}
      <Container>
        <Row>
          <Col className="ml-auto mr-auto" md="12">
            <Card className="card-signup text-center dp-box ">
              <div className="dfltDiv extra_text_addedsign">
                <div className="plnCrd">
                  <Row>
                    <Col md="7">
                      <div className="paymnt_img">
                        {/* <Button
                          className="btn-round"
                          color="info"
                          size="sm"
                          type="button"
                          onClick={(event) => history.push("/dashboard/plans")}
                        >
                          See All Plans
                        </Button> */}
                        <h1>Manual Paying for Subscription of  Project</h1>
                        <h2>{projectDetails.name}</h2>
                        <img src="https://mcmscache.epapr.in/post_images/website_132/new_post_images/618a17fe99f36_Group-66.png"></img>
                      </div>
                    </Col>
                    <Col md="5">
                      {showLoader ? (
                        <Spinner animation="border" role="status">
                          <span className="sr-only">Loading...</span>
                        </Spinner>
                      ) : (
                        <div className="checkOutCard">
                          <CardTitle tag="h6">
                            {/* {planDetails.plan_group_id
                              ? planDetails.plan_group_id.name
                              : ""} */}
                          </CardTitle>

                          <CardBody>
                            <Table className="pCardTbl">
                              
                              <tr>
                                <td>
                                  Subscription Amount
                                </td>
                                <td>
                                  <i
                                    className="fa fa-inr"
                                    style={{ fontSize: "15px" }}
                                  />
                                  {subscription.recurring_amount}
                                </td>
                              </tr>
                              <tr>
                                  <td>
                                    Paid Count
                                  </td>
                                  <td>
                                    {subscription.paid_count}
                                  </td>
                                </tr>
                              {subscription.current_end ? (
                                <tr>
                                  <td>
                                    Payment due On
                                  </td>
                                  <td>
                                    <Moment format="DD MMM YYYY">{new Date(subscription.current_end*1000)}</Moment>
                                  </td>
                                </tr>
                              ) : (
                                ""
                              )}

                              <tr>
                                <td></td>
                                <td>
                                  
                                </td>
                              </tr>
                            </Table>
                            {showProceedButton ? (
                              <Button
                                className="btn-round btnBlue"
                                onClick={async () => {
                                  processPayment(projectId, subscriptionId);
                                }}
                              >
                                Proceed To Payment
                              </Button>
                            ) : (
                              ""
                            )}
                            {showLoaderAtButton ? (
                              <Spinner animation="border" role="status">
                                <span className="sr-only">Loading...</span>
                              </Spinner>
                            ) : (
                              ""
                            )}
                          </CardBody>
                        </div>
                      )}
                    </Col>
                  </Row>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
      <div
        className="full-page-background"
        style={{
          backgroundImage: `url(${require("../../assets/img/bg/jan-sendereks.jpg")})`,
        }}
      />
    </div>
  );
};

export default PayManual;
